module.exports = __webpack_public_path__ + "static/media/CO.dba6a1fb.png";